import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import DigitalSignaturePanel from "./DigitalSignaturePanel";
import SignerCertificateSettings from "./SignerCertificateSettings";
import { getDigitalSignatureConfig } from "../common/settingsApi";

// Tab "Digital signature": tải cấu hình một lần rồi chia cho 2 card — kết nối
// (Hub-Sign + SmartCA) và chứng thư người ký. Card nào lưu thì trả dữ liệu mới về
// đây để card kia (vd danh sách việc còn thiếu) cập nhật theo.
const DigitalSignatureTab = () => {
  const [data, setData] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    getDigitalSignatureConfig()
      .then((res) => setData(res.data))
      .catch((e) => {
        setFailed(true);
        toast.error(e?.response?.data?.error || "Failed to load digital signature settings.");
      });
  }, []);

  if (failed) {
    return <div className="tw-py-10 tw-text-center tw-text-sm tw-text-geist-fg-3">Could not load digital signature settings.</div>;
  }
  return (
    <div className="tw-space-y-4">
      <DigitalSignaturePanel data={data} onSaved={setData} />
      {data && <SignerCertificateSettings data={data} onSaved={setData} />}
    </div>
  );
};

export default DigitalSignatureTab;
